import React, { useState, useEffect } from 'react';
import { Box, Typography, Avatar, Button } from '@mui/material';
import Modal from 'components/common/Modal';
import TeamIosDarkToggle from 'team/shared/components/button/TeamIosDarkToggle';
import DarkButtonWithIcon from 'components/common/button/DarkButtonWithIcon';
import avatarPlaceholder from 'images/avatar-cropped.png';

const EditAdminStatusModal = ({ open, onClose, member, onApply }) => {
    const [isAdmin, setIsAdmin] = useState(member?.role === 'admin');

    useEffect(() => {
        if (open && member) {
            setIsAdmin(member.role === 'admin');
        }
    }, [open, member]);

    const handleToggle = (event) => {
        event.stopPropagation();
        setIsAdmin(event.target.checked);
    };

    const handleApply = (event) => {
        if (event) event.stopPropagation();
        onApply(isAdmin ? 'admin' : 'member');
        onClose();
    };

    const handleCancel = (event) => {
        if (event) event.stopPropagation();
        onClose();
    };

    // Extract member info
    const fullName = member?.defaultCard?.contact_info?.fullName || member?.user?.fullName || 'Unknown User';
    const email = member?.defaultCard?.contact_info?.email || member?.user?.email || '';
    const profilePictureUrl = member?.defaultCard?.profilePictureUrl || member?.user?.profilePictureUrl || null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            width="400px"
            height="auto"
            borderRadius={8}
        >
            <Box 
                sx={{ p: 1 }} 
                onClick={(e) => e.stopPropagation()}
            >
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 3, textAlign: 'center' }}>
                    Admin Roles
                </Typography>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ color: '#828282', fontWeight: 600, mb: 1.5, fontSize: '0.85rem' }}>
                        Member
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar
                            src={profilePictureUrl || avatarPlaceholder}
                            sx={{ width: 48, height: 48 }}
                        />
                        <Box>
                            <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#111' }}>
                                {fullName}
                            </Typography>
                            <Typography sx={{ color: '#828282', fontSize: '0.8rem', fontWeight: 500 }}>
                                {email}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        backgroundColor: '#f7f7f7',
                        borderRadius: '12px',
                        padding: '16px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 4
                    }}
                >
                    <Typography sx={{ fontWeight: 600, color: '#333', fontSize: '0.9rem' }}>
                        Team Admin
                    </Typography>
                    <TeamIosDarkToggle
                        checked={isAdmin}
                        onChange={handleToggle}
                        onClick={(e) => e.stopPropagation()}
                    />
                </Box>

                <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'flex-end' }}>
                    <Button
                        onClick={handleCancel}
                        sx={{
                            backgroundColor: 'white',
                            color: '#4f4f4f',
                            borderRadius: '20px',
                            border: '1px solid #e3e3e3',
                            textTransform: 'none',
                            fontSize: '0.75rem',
                            fontWeight: '600',
                            padding: '6px 20px',
                            '&:hover': {
                                backgroundColor: 'white',
                                boxShadow: 2,
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <DarkButtonWithIcon
                        text="Apply Roles"
                        onClick={handleApply}
                        sx={{ 
                            px: 3, 
                            fontSize: '0.75rem', 
                            height: '34px',
                            minHeight: '34px'
                        }}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default EditAdminStatusModal;
